import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "@/components/Layout";
import { SmoothScroll } from "@/components/SmoothScroll";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Amenities from "@/pages/Amenities";
import Visitors from "@/pages/Visitors";
import NewResidents from "@/pages/NewResidents";
import Relocation from "@/pages/Relocation";
import Info from "@/pages/Info";
import Policies from "@/pages/Policies";
import Community from "@/pages/Community";
import Library from "@/pages/Library";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <Toaster position="top-right" richColors />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/amenities" element={<Amenities />} />
            <Route path="/visitors" element={<Visitors />} />
            <Route path="/residents" element={<NewResidents />} />
            <Route path="/relocation" element={<Relocation />} />
            <Route path="/info" element={<Info />} />
            <Route path="/policies" element={<Policies />} />
            <Route path="/community" element={<Community />} />
            <Route path="/library" element={<Library />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
